import { DatePickerSchemeDefinition } from "./date-picker-types";
import { BackgroundColor } from "../../background/constants/background-types";
import * as AllColors from "../../../constants/colors";
import { toConstantCase } from "../../../utils/string-format";
import { createDatePickerMapDefinition } from "../../../utils/scheme-helper";

function createSchemes() {
  let newSchemes: AllColors.DatePickerSchemeConfiguration<DatePickerSchemeDefinition> = {};

  AllColors.DATE_PICKER_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      fontColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      popupBackgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      popupBorderColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      popupFocusBorderColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      separatorColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      dayBorderHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      dayBorderSelectedColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      dayBackgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      dayBackgroundTodayColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      dayFontDisabledColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      dayFontOtherMonthColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      monthYearButtonBorderColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      scrollbarBackgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_2`],
      scrollbarThumbColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      monthYearToggleBorderColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      monthYearToggleBorderHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      monthYearToggleBorderActiveColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      monthYearToggleBackgroundActiveColor: AllColors[`COLOR_BRIGHT`],
      internalInputScheme: ""
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });

  return newSchemes;
}

export const DATE_PICKER_SCHEME_CONFIG: AllColors.DatePickerSchemeConfiguration<DatePickerSchemeDefinition> = createSchemes();

export const DATE_PICKER_SCHEME_MAP: Map<BackgroundColor | "default", DatePickerSchemeDefinition> = new Map(
  Object.entries(createDatePickerMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    DATE_PICKER_SCHEME_CONFIG[config as string]
  ])
);
